import { apiFetch } from "~/lib/fetchClient";

// Thin wrapper over apiFetch for the connected-call voicemail-drop endpoint
// (PR 3 #859). The path is relative to the /api/v1 prefix apiFetch already
// applies. The drop-specific params are `call_sid`, an optional `recording_id`
// (absent => the server uses the caller's default), and optional `body` (the
// dialer notes to persist on the phone-call activity the backend creates).
//
// NOTE: apiFetch's JSON client merges its `defaultData()` into every JSON
// body, so the request body also carries `product` (and apiFetch adds the
// `team` header) — the wire body is NOT strictly the drop params. The backend
// reads only the drop params from it.
//
// Success: 201 { status: "accepted" | "already_accepted" }
// Failure (before Twilio accepts): 422 { errors: ["..."] }
export const voicemailDropsApi = {
  // POST /leads/:lead_id/voicemail_drops -> { status }
  drop: (leadId, { callSid, recordingId, body } = {}) => {
    const json = { call_sid: callSid };
    // Only send recording_id when a specific recording is chosen; omitting it
    // lets the server fall back to the caller's default recording.
    if (recordingId != null) {
      json.recording_id = recordingId;
    }
    // Forward any notes typed in the dialer. The accepted path suppresses the
    // browser-side activity creation (the backend creates the phone-call
    // activity), so notes must ride along on the drop request to be persisted.
    if (body) {
      json.body = body;
    }
    return apiFetch.post(`/leads/${leadId}/voicemail_drops`, { json });
  },
};
